export default __webpack_public_path__ + "static/media/BenjaminAnswer.41a5bfec.png";